module.exports = __webpack_public_path__ + "static/media/personCloud.f944afd7.png";